import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { LocaleLayout } from '@/components/layout/LocaleLayout'
import { ConversationsPage } from '@/pages/ConversationsPage'
import { KnowledgePage } from '@/pages/KnowledgePage'
import { ActionsPage } from '@/pages/ActionsPage'
import { AutomationCanvasPage } from '@/pages/AutomationCanvasPage'
import { ToolsPage } from '@/pages/ToolsPage'
import { SkillsPage } from '@/pages/SkillsPage'
import { AgentsPage } from '@/pages/AgentsPage'
import { ChannelAgentsPage } from '@/pages/ChannelAgentsPage'
import { AgentStudioFlowPage } from '@/pages/AgentStudioFlowPage'
import { CallAgentsPage } from '@/pages/CallAgentsPage'
import { ToolStudioFlowPage } from '@/pages/ToolStudioFlowPage'
import { KeysSecretsPage } from '@/pages/KeysSecretsPage'
import { SettingsPage } from '@/pages/PlaceholderPages'
import { MetaIntegrationPage } from '@/pages/MetaIntegrationPage'
import { LoginPage } from '@/pages/LoginPage'
import { BrainPage } from '@/pages/BrainPage'
import { WebSocketProvider } from '@/contexts/WebSocketContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { FEATURE_PREVIEW_IA } from '@/config/feature-flags'
import { PreviewIAPage } from '@/features/preview-ia/components/PreviewIAPage'

export function AppRouter() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <BrowserRouter>
          <Routes>
            {/* Public login route */}
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/web/*"
              element={
                FEATURE_PREVIEW_IA
                  ? <Navigate to="/en/preview-ia" replace />
                  : <Navigate to="/en/conversations" replace />
              }
            />

            {/* Redirect root to /en (protected) */}
            <Route path="/" element={
              <ProtectedRoute>
                <Navigate to="/en" replace />
              </ProtectedRoute>
            } />

            {/* Protected routes with locales */}
            <Route path="/:lang/*" element={
              <ProtectedRoute>
                <LocaleLayout />
              </ProtectedRoute>
            }>
              <Route path="" element={<Navigate to="conversations" replace />} />
              <Route path="brain" element={<BrainPage />} />
              <Route path="conversations" element={<ConversationsPage />} />
              <Route path="actions" element={<ActionsPage />} />
              <Route path="actions/new/canvas" element={<AutomationCanvasPage />} />
              <Route path="actions/:automationId/canvas" element={<AutomationCanvasPage />} />
              <Route path="agent-studio" element={<AgentStudioFlowPage />} />
              <Route path="agent-studio/call-agents" element={<CallAgentsPage />} />
              <Route path="tool-studio" element={<ToolStudioFlowPage />} />
              <Route path="skills" element={<SkillsPage />} />
              <Route path="tools" element={<ToolsPage />} />
              <Route path="agents" element={<AgentsPage />} />
              <Route path="channel-agents" element={<ChannelAgentsPage />} />
              <Route path="keys-secrets" element={<KeysSecretsPage />} />
              <Route path="knowledge" element={<KnowledgePage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="settings/meta" element={<MetaIntegrationPage />} />
              <Route
                path="preview-ia"
                element={FEATURE_PREVIEW_IA ? <PreviewIAPage /> : <Navigate to="../conversations" replace />}
              />
            </Route>

            {/* Catch-all: redirect to /en (will trigger auth check) */}
            <Route path="*" element={<Navigate to="/en" replace />} />
          </Routes>
        </BrowserRouter>
      </WebSocketProvider>
    </AuthProvider>
  )
}
